<style scoped lang="scss">
::v-deep .el-select .el-input {
  width: auto !important;
}

.el-select .el-input .gantt_split_parent,
.gantt_split_subproject {
  opacity: 0;
}

::v-deep .gantt_task_line {
  height: 26px !important;
  margin-top: 2px;
}

::v-deep .gantt_task_line.gantt_task_inline_color .gantt_task_progress {
  background-color: rgba(54, 54, 54, 0.2);
  opacity: 1;
}

::v-deep .scale_class {
  background-color: #f5f7fa !important;
}

::v-deep .column_class {
  background-color: #f5f7fa !important;
}

::v-deep .gantt_scale_cell {
  color: #454545 !important;
}

::v-deep .gantt_scale_cell_minute {
  display: none;
}

::v-deep .gantt_task_line.gantt_task_inline_color {
  border-color: #e8e8e8;
}

::v-deep .gantt_split_parent,
.gantt_split_subproject {
  opacity: 0;
}

::v-deep .gantt_task_line {
  //border: none !important;
  border-radius: 0px;
}

::v-deep .gantt_task_line.highlight {
  //border: none !important;
  border-radius: 12.5px;
  border: 1px solid black;

  // box-shadow: 0 0 5px black;
}

::v-deep .gantt_task_line.nolight {
  //border: none !important;
  border-radius: 12.5px;
  box-shadow: none;
  border: none;
}

::v-deep .gantt_task_cell {
  border: none !important;
  border-radius: 0px;
}

::v-deep .column_weekend {
  background-color: #ecf5ff !important; // background-color: #ECF5FF !important
}

::v-deep .scale_weekend {
  color: #454545 !important;
  background-color: #ecf5ff !important; // background-color: #ECF5FF !important
}

::v-deep .gantt_grid_data .gantt_cell {
  color: inherit;
}

::v-deep .runColor {
  color: #67c23a !important; //0
}

::v-deep .idleColor {
  color: #e6a23c !important; //1
}

::v-deep .errorColor {
  color: #f56c6c !important; //3
}

::v-deep .offlineColor {
  color: #909399 !important; //-1
}
</style>

<template>
  <div id="device_load_gantt" style="width: 100%;height: 100%;padding: 20px;display:flex;flex-direction: column;" :style="{ width: exportWidth == 0 ? '100%' : exportWidth + 'px', height: exportHeight == 0 ? '100%' : exportHeight + 'px' }">
    <div style="width: 100%;display:flex;justify-content:space-between">
      <div>
        <el-form size="mini" :inline="true" class="demo-form-inline">
          <el-form-item :label="$t('xuanzeriqi')">
            <yi_time_input style="width:320px" type="daterange" format="yyyy-MM-dd" :start.sync="startTime" :end.sync="endTime" :placeholder="$t('xuanzeriqi')" :clearable="false"></yi_time_input>
          </el-form-item>
          <el-form-item :label="$t('suoshuzuzhi')">
            <yi_data_select :type="'organization'" :ids.sync="orgId"></yi_data_select>
          </el-form-item>
          <el-form-item :label="$t('jihuadanhao(jingzhun)')">
            <el-input v-model="planNo"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="getGantt()" :loading="loading" size="mini" type="primary" plain>{{ $t('shuaxin') }} </el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="display:flex;height:28px">
        <el-button v-if="utils.checkPower('web_scheduling_aps_ips_save')" :disabled="!needSave" @click="save()" size="mini" type="primary" :loading="loading">{{ $t('baocun') }} </el-button>

        <el-button v-if="utils.checkPower('web_scheduling_aps_scrollRearrangement')" @click="checkSchedulingDetails()" size="mini" plain :loading="loading">{{ $t('gundongchongpai') }} </el-button>
        <el-button v-if="utils.checkPower('web_scheduling_aps_batchIssue')" :disabled="needSave" @click="batchIssue()" size="mini" plain :loading="loading">{{ $t('piliangfafang') }} </el-button>
        <el-button v-if="utils.checkPower('web_scheduling_aps_ips_importInsertOrder')" :disabled="needSave" @click="isShowOrderImport = true" size="mini" plain>{{ $t('daoruchadan') }} </el-button>
        <el-button @click="showTable()" size="mini" plain :loading="loading">{{ $t('anshebeifafang') }} </el-button>
        <yi_cross_select v-if="isShowChadanButton" :disabled="needSave" :multiple="true" :max="99" style="margin-left:10px" :isButton="true" :isInput="true" @getItems="getImportWos" :ids.sync="importIds" :buttonTitle="'chadan'" component="web_scheduling_production_plan_list"></yi_cross_select>

        <!-- <el-button @click="setOrder()" size="mini" plain>{{$t('chadan')}}</el-button> -->
      </div>
    </div>

    <div style="width:100%;flex:1;" id="ganttContainer" class="ganttContainer" ref="ganttContainer"></div>
    <el-drawer :visible.sync="isShowDetailDialog" :show-close="false" :direction="'rtl'" :size="374" :destroy-on-close="true" :withHeader="false">
      <div style="margin: 40px 28px;" v-if="currentWo != null">
        <div style="width: 100%;display: flex;flex-flow: wrap;">
          <el-button :disabled="needSave || !(currentWo.status == '1')" :loading="loading" v-if="utils.checkPower('web_scheduling_aps_issue')" style="margin-right:10px;margin-bottom:10px;margin-left:0px" @click="issue()" size="mini" type="primary" plain>{{ $t('fafanggongdan') }} </el-button>

          <el-button :loading="loading" v-if="utils.checkPower('web_scheduling_aps_dismantlingDoc')" :disabled="needSave || !(currentWo.status == '1' || (currentWo.status == '2' && (currentWo.woObject.status == 2 || currentWo.woObject.status == 3 || currentWo.woObject.status == 4)))" style="margin-right:10px;margin-bottom:10px;margin-left:0px" @click="showSplitOrder()" size="mini" type="primary" plain>{{ $t('chaidan') }} </el-button>
          <el-button :loading="loading" :disabled="needSave || !(currentWo.status == '1' || currentWo.status == '3')" v-if="utils.checkPower('web_scheduling_aps_changeEquipment')" style="margin-right:10px;margin-bottom:10px;margin-left:0px" @click="showChangeEq()" size="mini" type="primary" plain>{{ $t('genghuanjitai') }} </el-button>
          <el-button :loading="loading" :disabled="needSave || !(currentWo.status == '1' || currentWo.status == '3')" v-if="utils.checkPower('web_scheduling_aps_changeMould')" style="margin-right:10px;margin-bottom:10px;margin-left:0px" @click="showChangeMould()" size="mini" type="primary" plain>{{ $t('genghuanmoju') }} </el-button>
          <!--web_scheduling_aps_lock-->
          <el-button v-if="false" :disabled="!(currentWo.status == '1' || currentWo.status == '2')" style="margin-right:10px;margin-bottom:10px;margin-left:0px" @click="locak()" size="mini" type="primary" plain>{{ $t('suoding') }} </el-button>
          <el-button :disabled="needSave || !(currentWo.status == '2' && currentWo.woObject.status == 2)" v-if="utils.checkPower('web_scheduling_aps_cancelIssue')" style="margin-right:10px;margin-bottom:10px;margin-left:0px" @click="cancelIssue()" size="mini" type="primary" plain>{{ $t('quxiaofafang') }} </el-button>
          <el-button :loading="loading" :disabled="needSave || !(currentWo.status == '1')" v-if="utils.checkPower('web_scheduling_aps_cancelScheduling')" style="margin-right:10px;margin-bottom:10px;margin-left:0px" @click="cancelScheduling()" size="mini" type="primary" plain>{{ $t('quxiaopaicheng') }} </el-button>
          <el-button v-if="utils.checkPower('web_scheduling_aps_forceClose')" :loading="loading" :disabled="needSave || !((currentWo.status == '2' && currentWo.woObject.status == 2) || (currentWo.status == '2' && currentWo.woObject.status == 4) || (currentWo.status == '2' && currentWo.woObject.status == 3 && currentWo.availableQuantity == 0))" style="margin-right:10px;margin-bottom:10px;margin-left:0px" @click="forceClose()" size="mini" type="primary" plain>{{ $t('qiangzhiguanbi') }} </el-button>
          <el-button v-if="utils.checkPower('web_scheduling_scheduling_detail_pending')" :loading="loading" :disabled="needSave || !(currentWo.woObject && currentWo.woObject.status == 4 && currentWo.status != '3')" style="margin-right:10px;margin-bottom:10px;margin-left:0px" @click="pending()" size="mini" type="primary" plain>{{ $t('guaqi') }} </el-button>
          <el-button v-if="utils.checkPower('web_scheduling_scheduling_detail_pending')" :loading="loading" :disabled="needSave || !(currentWo.status == '3')" style="margin-right:10px;margin-bottom:10px;margin-left:0px" @click="cancelPending()" size="mini" type="primary" plain>{{ $t('quxiaoguaqi') }} </el-button>
        </div>

        <el-tabs v-model="activeName">
          <el-tab-pane :label="$t('zhuchanpin')" :name="'zhuchanpin'">
            <el-progress style="margin-bottom: 10px;" :percentage="parseFloat(currentWo.woObject ? ((currentWo.woObject.productionQuantity / currentWo.schedulingQuantity) * 100).toFixed(1) : 0.0)"></el-progress>
            <el-descriptions :column="1">
              <el-descriptions-item :label="$t('shebeimingcheng')">{{ currentWo.equipmentName }}</el-descriptions-item>
              <el-descriptions-item :label="$t('chanpinbianma')">{{ currentWo.materialObject.code }} </el-descriptions-item>
              <el-descriptions-item :label="$t('chanpinmingcheng')">{{ currentWo.materialObject.name }} </el-descriptions-item>
              <el-descriptions-item :label="$t('mojubianhao')">{{ currentWo.mouldObject.no }}</el-descriptions-item>
              <el-descriptions-item :label="$t('mojumingcheng')">{{ currentWo.mouldObject.name }}</el-descriptions-item>
              <el-descriptions-item :label="$t('moqiangshu')">{{ currentWo.cavity }}</el-descriptions-item>
              <el-descriptions-item :label="$t('biaozhunzhouqi')">{{ currentWo.standardCycle / 1000 }} </el-descriptions-item>
              <el-descriptions-item :label="$t('paichanshuliang')">{{ currentWo.schedulingQuantity }} </el-descriptions-item>
              <el-descriptions-item :label="$t('shengchanshuliang')">
                {{ currentWo.woObject ? currentWo.woObject.productionQuantity : '-' }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('shengyushengchanshuliang')">
                {{ currentWo.woObject ? currentWo.woObject.planQuantity - currentWo.woObject.productionQuantity : '-' }}
              </el-descriptions-item>
              <el-descriptions-item v-if="currentWo.woObject" :label="$t('yibaogongliangpinshu')">
                {{ currentWo.woObject.finishGoodQuantity }}
              </el-descriptions-item>
              <el-descriptions-item v-if="currentWo.woObject" :label="$t('yibaogongbuliangpinshu')">
                {{ currentWo.woObject.finishBadQuantity }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('jiaoqi')">{{ currentWo.deliveryPeriodDate ? dayjs.unix(currentWo.deliveryPeriodDate / 1000).format('YYYY-MM-DD HH:mm:ss') : '-' }} </el-descriptions-item>
              <!-- <el-descriptions-item :label="$t('jihuakaishishijian')">{{ currentWo.planStartTime ? dayjs.unix(currentWo.planStartTime / 1000).format("YYYY-MM-DD HH:mm:ss") : "-" }} </el-descriptions-item>
              <el-descriptions-item :label="$t('jihuawanchengshijian')">
                {{ currentWo.planEndTime ? dayjs.unix(currentWo.planEndTime / 1000).format("YYYY-MM-DD HH:mm:ss") : "-" }}
              </el-descriptions-item> -->

              <el-descriptions-item :label="$t('jihuakaishishijian')">{{ dayjs(currentTask.start_date).format('YYYY-MM-DD HH:mm:ss') }} </el-descriptions-item>
              <el-descriptions-item :label="$t('jihuawanchengshijian')">{{ dayjs(currentTask.end_date).format('YYYY-MM-DD HH:mm:ss') }} </el-descriptions-item>

              <el-descriptions-item v-if="currentWo.woObject" :label="$t('shijikaishishijian')">{{ currentWo.woObject.actualStartTime ? dayjs.unix(currentWo.woObject.actualStartTime / 1000).format('YYYY-MM-DD HH:mm:ss') : '-' }} </el-descriptions-item>
              <el-descriptions-item :label="$t('jihuadanhao')">{{ currentWo.planObject ? currentWo.planObject.no : '-' }} </el-descriptions-item>
              <el-descriptions-item :label="$t('shengchangongdanhao')">
                {{ currentWo.woObject ? currentWo.woObject.no : '-' }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('ERPgongdanhao')">{{ currentWo.woObject ? currentWo.woObject.erpNo : '-' }} </el-descriptions-item>
              <el-descriptions-item :label="$t('erpwuliaobianma')">{{ currentWo.materialObject ? currentWo.materialObject.erpMaterialCode : '-' }} </el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>
          <el-tab-pane :label="$t('wuliaoxinxi')" :name="'wuliaoxinxi'">
            <el-descriptions :column="1">
              <el-descriptions-item :label="$t('wuliaobianma')">{{ currentWo.materialObject.code }}</el-descriptions-item>
              <el-descriptions-item :label="$t('wuliaomingcheng')">{{ currentWo.materialObject.name }} </el-descriptions-item>
              <el-descriptions-item :label="$t('jibenfenlei')">
                {{ $t(store.state.dictJsonAll['CUSTOMER_MATERIAL_TYPE'][currentWo.materialObject.type]) }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('chanpinfenlei')">
                {{ store.state.dictJsonAll['GYLXCPFL'][currentWo.materialObject.value] }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('morendanwei')">
                {{ store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][currentWo.materialObject.defaultUnit] }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('guige')">{{ currentWo.materialObject.spec }}</el-descriptions-item>
              <el-descriptions-item :label="$t('dangqianliaohao')">{{ currentWo.materialObject.no }} </el-descriptions-item>
              <el-descriptions-item :label="$t('jiliangdanwei')">{{ currentWo.materialObject.unit }} </el-descriptions-item>
              <el-descriptions-item :label="$t('baozhuangfangshi')">{{ currentWo.materialObject.pack }} </el-descriptions-item>
              <el-descriptions-item :label="$t('maozhong') + '(g)'">
                {{ currentWo.materialObject.grossWeight != null ? currentWo.materialObject.grossWeight / 1000 : '-' }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('jingzhong') + '(g)'">
                {{ currentWo.materialObject.netWeight != null ? currentWo.materialObject.netWeight / 1000 : '-' }}
              </el-descriptions-item>
              <el-descriptions-item :label="$t('yanse')">{{ currentWo.materialObject.color }}</el-descriptions-item>
              <el-descriptions-item :label="$t('sehao')">{{ currentWo.materialObject.colorNum }}</el-descriptions-item>
              <el-descriptions-item :label="$t('caizhi')">{{ currentWo.materialObject.ingredient }}</el-descriptions-item>
              <el-descriptions-item :label="$t('miaoshu')">{{ currentWo.materialObject.describe }}</el-descriptions-item>
            </el-descriptions>
          </el-tab-pane>

          <el-tab-pane v-if="currentWo.childrenMaterialList" :label="$t('fuchanpin')" :name="'fuchanpin'">
            <div style="margin-bottom: 40px;" v-for="childMaterial in currentWo.childrenMaterialList">
              <el-descriptions :column="1">
                <el-descriptions-item :label="$t('wuliaobianma')">{{ childMaterial.code }}</el-descriptions-item>
                <el-descriptions-item :label="$t('wuliaomingcheng')">{{ childMaterial.name }}</el-descriptions-item>
                <el-descriptions-item :label="$t('jibenfenlei')">
                  {{ $t(store.state.dictJsonAll['CUSTOMER_MATERIAL_TYPE'][childMaterial.type]) }}
                </el-descriptions-item>
                <el-descriptions-item :label="$t('chanpinfenlei')">
                  {{ store.state.dictJsonAll['GYLXCPFL'][childMaterial.value] }}
                </el-descriptions-item>
                <el-descriptions-item :label="$t('morendanwei')">
                  {{ store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][childMaterial.defaultUnit] }}
                </el-descriptions-item>
                <el-descriptions-item :label="$t('guige')">{{ childMaterial.spec }}</el-descriptions-item>
                <el-descriptions-item :label="$t('dangqianliaohao')">{{ childMaterial.no }}</el-descriptions-item>
                <el-descriptions-item :label="$t('jiliangdanwei')">{{ childMaterial.unit }}</el-descriptions-item>
                <el-descriptions-item :label="$t('baozhuangfangshi')">{{ childMaterial.pack }}</el-descriptions-item>
                <el-descriptions-item :label="$t('maozhong') + '(g)'">
                  {{ childMaterial.grossWeight != null ? childMaterial.grossWeight / 1000 : '-' }}
                </el-descriptions-item>
                <el-descriptions-item :label="$t('jingzhong') + '(g)'">
                  {{ childMaterial.netWeight != null ? childMaterial.netWeight / 1000 : '-' }}
                </el-descriptions-item>
                <el-descriptions-item :label="$t('yanse')">{{ childMaterial.color }}</el-descriptions-item>
                <el-descriptions-item :label="$t('sehao')">{{ childMaterial.colorNum }}</el-descriptions-item>
                <el-descriptions-item :label="$t('caizhi')">{{ childMaterial.ingredient }}</el-descriptions-item>
                <el-descriptions-item :label="$t('miaoshu')">{{ childMaterial.describe }}</el-descriptions-item>
              </el-descriptions>
              <hr />
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </el-drawer>

    <el-dialog :visible.sync="isShowChangeMould" :title="$t('genghuanmoju')" append-to-body>
      <div style="width:100%;display:flex;justify-content:center;padding:40px">
        <el-form size="mini" :inline="true" class="demo-form-inline">
          <el-form-item :label="$t('xuanzemoju')">
            <el-select v-model="changeMould" style="width: 300px;">
              <el-option v-for="mould in changeMoulds" :key="mould.id" :label="mould.name" :value="mould.id">
                <span style="">{{ mould.name }}</span>
                <span>&nbsp;&nbsp;&nbsp;</span>
                <span style=" color: #8492a6; font-size: 13px">{{ mould.no }}</span>
                <span>&nbsp;&nbsp;&nbsp;</span>
                <span style="">{{ $t(store.state.dictJsonAll['BASIC_MOULD_STATUS'][mould.status]) }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="isShowChangeMould = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" @click="changeMouldF()" :loading="loading">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="isShowChangeEq" :title="$t('genghuanjitai')" append-to-body>
      <div style="width:100%;display:flex;justify-content:center;padding:40px">
        <el-form size="mini" :inline="true" class="demo-form-inline">
          <el-form-item :label="$t('xuanzeshebei')">
            <el-select v-model="changeEq">
              <el-option v-for="eq in changeEqs" :key="eq.id" :label="eq.name" :value="eq.id">
                <span style="float: left">{{ eq.name }}</span>
                <span style="float: right; color: #8492a6; font-size: 13px">{{ eq.sn }}</span>
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="isShowChangeEq = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" @click="changeEquipment()" :loading="loading">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="isShowSplitOrder" :title="$t('chaidan')" append-to-body width="502px">
      <div v-if="currentWo" style="width:100%;padding:20px 100px">
        <el-form size="mini" :inline="false" class="demo-form-inline">
          <el-form-item :label="$t('jihuashuliang')" noborder>
            {{ currentWo.schedulingQuantity }}
          </el-form-item>
          <el-form-item :label="$t('kechaidanshuliang')" noborder>
            {{ currentWo.availableQuantity }}
          </el-form-item>
          <el-form-item v-for="(num, i) in splitOrders" :label="$t('shuliang')" noborder>
            <div style="display:flex">
              <el-input-number v-model="splitOrders[i]" :min="0" :max="maxSpilit(i)" label="描述文字"></el-input-number>
              <el-button @click="splitOrders.splice(i, 1)" icon="el-icon-remove-outline" type="text"></el-button>
            </div>
          </el-form-item>
        </el-form>
        <div>
          <el-button @click="splitOrders.push(0)" icon="el-icon-circle-plus-outline" type="text">
            {{ $t('zengjiayitiaochaidan') }}
          </el-button>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="isShowSplitOrder = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" @click="splitOrder()" :loading="loading">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
    <!-- 导入excel -->
    <importExcel :show.sync="isShowOrderImport" />
    <!-- <el-dialog :visible.sync="isShowOrderAdd" :title="'daoruchadan'" append-to-body>
			<span slot="footer" class="dialog-footer">
				<el-button type="default" size="mini" @click="visible = false">{{$t('quxiao')}}</el-button>
				<el-button type="primary" size="mini" @click="importData()">{{$t('baocun')}}</el-button>
			</span>
		</el-dialog> -->

    <el-dialog :visible.sync="isShowTableDialog" :title="$t('anshebeifafang')" append-to-body width="80%">
      <div class="dialog-scroller">
        <equipmentIssue ref="equipmentIssueRef" v-if="isShowTableDialog"></equipmentIssue>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="default" size="mini" @click="isShowTableDialog = false">{{ $t('quxiao') }}</el-button>
        <el-button type="primary" size="mini" @click="issued()" :loading="issuedLoading">{{ $t('baocun') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import equipmentIssue from '@@/pages/web/scheduling/aps/equimpent_issue.vue';
import importExcel from '@@/pages/web/scheduling/aps/import_excel';
import html2canvas from 'html2canvas';

const gantt = Gantt.getGanttInstance();
export default {
  name: 'web_scheduling_aps_index',
  components: {
    importExcel,
    equipmentIssue
  },
  data() {
    return {
      issuedLoading: false,
      isShowTableDialog: false,
      planNo: null,
      orgId: null,
      startTime: this.dayjs()
        .subtract(0, 'days')
        .startOf('days')
        .valueOf(),
      endTime: this.dayjs()
        .subtract(0, 'days')
        .add(14, 'days')
        .endOf('days')
        .valueOf(),

      // startTime: this.dayjs().subtract(7, 'days').startOf('days').valueOf(),
      // endTime: this.dayjs().subtract(1, 'days').add(7, "days").endOf('days').valueOf(),
      loading: false,
      loading: false,
      jiaoqiMarker: '',
      isAllowLeave: false,
      loading: false,
      needSave: false,
      isShowChadanButton: true,
      isShowOrderImport: false,
      isShowChangeMould: false,
      isShowSplitOrder: false,
      isShowChangeEq: false,
      activeName: 'zhuchanpin',
      isShowDetailDialog: false,
      changeEqs: [],
      changeEq: null,
      changeMoulds: [],
      changeMould: null,
      splitOrders: [],

      tasks: {
        data: []
      },

      importIds: [],

      //导出参数
      exportWidth: 0,
      exportHeight: 0,
      isExporting: false,

      //数据
      eqs: [],

      currentTask: null,
      currentWo: null,

      importWoIds: []
    };
  },

  computed: {
    maxSpilit() {
      return index => {
        let sum = 0;

        for (let i = 0; i < this.splitOrders.length; i++) {
          if (i == index) {
            continue;
          }
          let plus = parseInt(this.splitOrders[i]);

          sum += isNaN(plus) ? 0 : plus;
        }

        return this.currentWo.availableQuantity - sum;
      };
    }
  },

  created() {
    this.utils.event_hub.$off('APS_BEFORE_CLOSE');
    this.utils.event_hub.$on('APS_BEFORE_CLOSE', tab => {
      if (!this.needSave) {
        this.isAllowLeave = true;
        this.store.commit('DELETE_ROUTER_TAB', tab);
        return;
      }
      this.$confirm(this.$t('shangweibaocunxiugai,querenlikai?'))
        .then(_ => {
          //删除自己的时候，是不需要再触发beforeRouteLeave的，所以这里加个标记，跳过拦截器
          this.isAllowLeave = true;
          this.store.commit('DELETE_ROUTER_TAB', tab);
        })
        .catch(_ => {});
    });

    this.utils.event_hub.$on('SCHEDULING_APS_REFRESH', () => {
      this.importInsertOrder();
    });
  },
  destroyed() {
    this.utils.event_hub.$off('SCHEDULING_APS_REFRESH');
    gantt.clearAll();
  },
  activated() {
    this.resize();
  },
  beforeRouteLeave(to, from, next) {
    if (this.isAllowLeave == true) {
      next(true);
      return;
    }

    if (this.needSave) {
      this.$confirm(this.$t('shangweibaocunxiugai,querenlikai?'))
        .then(_ => {
          next(true);
        })
        .catch(_ => {
          next(false);
        });
    } else {
      next(true);
    }
  },

  mounted() {
    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });

    // gantt.config.autosize = true
    gantt.config.grid_height = 80;
    gantt.config.scale_height = 50;
    gantt.config.fit_tasks = true;
    gantt.config.min_column_width = 2;
    gantt.config.time_step = 60;
    gantt.i18n.setLocale('cn');
    gantt.config.work_time = false; // removes non-working time from calculations
    gantt.config.skip_off_time = false; // hides non-working time in the chart
    gantt.plugins({
      marker: true,
      tooltip: true
    });

    gantt.config.duration_unit = 'minute';

    gantt.config.drag_links = false;
    gantt.config.drag_move = true;
    gantt.config.drag_progress = false;
    gantt.config.drag_resize = false;
    gantt.config.date_format = '%Y-%m-%d %H:%i';
    gantt.templates.grid_file = function(item) {
      return '';
    };
    gantt.templates.scale_row_class = function(scale) {
      return 'scale_class';
    };
    gantt.templates.grid_header_class = function(columnName, column) {
      return 'column_class';
    };
    gantt.templates.grid_row_class = function(start, end, task) {
      if (task.equipmentCurrentStatus == 0) {
        return 'runColor';
      } else if (task.equipmentCurrentStatus == 1) {
        return 'idleColor';
      } else if (task.equipmentCurrentStatus == 3) {
        return 'errorColor';
      } else {
        return 'offlineColor';
      }
    };

    gantt.templates.timeline_cell_class = (task, date) => {
      if (date.getDay() == 0 || date.getDay() == 6) {
        return 'column_weekend';
      }
    };

    gantt.config.scales = [
      {
        unit: 'month',
        step: 1,
        format: '%Y' + this.$t('nian') + '%M',
        css: function(date) {
          return 'scale_class';
        }
      },
      {
        unit: 'day',
        step: 1,
        format: '%d %D',
        css: function(date) {
          if (date.getDay() == 0 || date.getDay() == 6) {
            return 'scale_weekend';
          } else {
            return 'scale_class';
          }
        }
      }
    ];
    gantt.config.columns = [
      {
        name: 'text',
        label: "<img style='object-fit: contain;width: 150px;height: 50px' src='" + require('@@/assets/img/web/production_management/gantt-task1.svg') + "' />",
        tree: true,
        width: 136
      }
    ];

    // gantt.templates.leftside_text = (start, end, task) => {
    // 	var state = gantt.getState(),
    // 		modes = gantt.config.drag_mode;

    // 	if (state.drag_id == task.id) {
    // 		if (state.drag_mode == modes.move || (state.drag_mode == modes.resize && state.drag_from_start)) {
    // 			return this.dayjs(task.start_date).format('MM-DD HH:mm')
    // 		}
    // 	}

    // 	return "";
    // };
    gantt.attachEvent('onGanttReady', () => {
      gantt.templates.tooltip_text = (start, end, task) => {
        if (task.type == 'subproject') {
          return '';
        }

        if (task.dType == 'change') {
          let txt = "<div style='padding:10px;line-height:24px;font-size:15px'>";
          txt += '<b>' + this.$t('huanxingcaozuo') + ':</b> ' + this.$t(task.changeType) + '<br/>';
          txt += '<b>' + this.$t('jihuakaishishijian') + ':</b> ' + this.dayjs(task.start_date).format('YYYY-MM-DD HH:mm:ss') + '<br/>';
          txt += '<b>' + this.$t('jihuajieshushijian') + ':</b> ' + this.dayjs(task.end_date).format('YYYY-MM-DD HH:mm:ss') + '<br/>';

          txt += '</div>';
          return txt;
        }

        if (task.dType != 'task') {
          return false;
        }

        //找出同模具的又时间重叠的
        let chongtuWos = [];
        for (var i = 0; i < this.tasks.data.length; i++) {
          let data = this.tasks.data[i];

          if (task.id == data.id) {
            continue;
          }
          if (data.dType != 'task') {
            continue;
          }
          if (task.wo.mouldId != data.wo.mouldId) {
            continue;
          }
          if (data.parent == task.parent) {
            continue;
          }
          if (!this.checkTimes(task.start_date, task.end_date, data.start_date, data.end_date)) {
            chongtuWos.push(data);
          }
        }

        let txt = "<div style='padding:10px;line-height:24px;font-size:15px'>";
        txt += '<b>' + this.$t('jihuadanhao') + ':</b> ' + task.wo.planObject.no + '<br/>';

        //   txt += "<b>" + this.$t("jihuakaishishijian") + ":</b> " + this.dayjs(task.wo.planStartTime).format("YYYY-MM-DD HH:mm:ss") + "<br/>";
        // txt += "<b>" + this.$t("jihuajieshushijian") + ":</b> " + this.dayjs(task.wo.planEndTime).format("YYYY-MM-DD HH:mm:ss") + "<br/>";

        txt += '<b>' + this.$t('jihuakaishishijian') + ':</b> ' + this.dayjs(task.start_date).format('YYYY-MM-DD HH:mm:ss') + '<br/>';
        txt += '<b>' + this.$t('jihuajieshushijian') + ':</b> ' + this.dayjs(task.end_date).format('YYYY-MM-DD HH:mm:ss') + '<br/>';
        if (task.wo.woObject) {
          txt += '<b>' + this.$t('shijikaishishijian') + ':</b> ' + (task.wo.woObject.actualStartTime ? this.dayjs.unix(task.wo.woObject.actualStartTime / 1000).format('YYYY-MM-DD HH:mm:ss') : '-') + '<br/>';
          txt += '<b>' + this.$t('shengchanshuliang') + ':</b> ' + task.wo.woObject.productionQuantity + '<br/>';
        }
        txt += '<b>' + this.$t('jiaoqi') + ':</b> ' + (task.wo.deliveryPeriodDate ? this.dayjs.unix(task.wo.deliveryPeriodDate / 1000).format('YYYY-MM-DD HH:mm:ss') : '-') + '<br/>';
        txt += '<b>' + this.$t('jihuashuliang') + ':</b> ' + task.wo.schedulingQuantity + '<br/>';
        txt += '<b>' + this.$t('mojubianhao') + ':</b> ' + task.wo.mouldObject.no + '<br/>';
        txt += '<b>' + this.$t('chanpinbianma') + ':</b> ' + task.wo.materialObject.code + '<br/>';
        txt += '<b>' + this.$t('erpwuliaobianma') + ':</b> ' + (task.wo.materialObject.erpMaterialCode == null ? '' : task.wo.materialObject.erpMaterialCode) + '<br/>';

        if (chongtuWos.length > 0) {
          txt += '<br/><b>' + this.$t('mojuchongtu') + ':</b> ';
          for (var i = 0; i < chongtuWos.length; i++) {
            txt += "<br/><span style='color:red'> " + this.$t('jihuadanhao') + ':' + (chongtuWos[i].wo.planObject ? chongtuWos[i].wo.planObject.no : '-') + '</span>';
            txt += "&nbsp&nbsp&nbsp<span style='color:red'> " + this.$t('shebei') + ':' + chongtuWos[i].wo.equipmentObject.name + '</span>';
          }
        }
        txt += '</div>';
        return txt;
      };
    });

    gantt.templates.task_class = (start, end, task) => {
      let stylee = 'nolight';

      if (gantt.isSelectedTask(task.id)) {
        return 'highlight';
      }

      //找出当前被选中的
      let currentTask = null;
      for (var i = 0; i < this.tasks.data.length; i++) {
        let data = this.tasks.data[i];
        if (gantt.isSelectedTask(data.id) && data.dType == 'task') {
          currentTask = data;
        }
      }
      if (currentTask == null) {
        return 'nolight';
      }

      //找出跟当前选中的模具冲突的
      let chongtuWos = [];
      for (var i = 0; i < this.tasks.data.length; i++) {
        let data = this.tasks.data[i];
        if (currentTask.id == data.id) {
          continue;
        }
        if (data.dType != 'task') {
          continue;
        }
        if (currentTask.wo.mouldId != data.wo.mouldId) {
          continue;
        }
        if (data.parent == currentTask.parent) {
          continue;
        }
        if (!this.checkTimes(currentTask.start_date, currentTask.end_date, data.start_date, data.end_date)) {
          chongtuWos.push(data);
        }
      }
      if (chongtuWos.length > 0) {
        // console.log(chongtuWos);
      }
      //判断是否是冲突之一
      for (var i = 0; i < chongtuWos.length; i++) {
        let data = chongtuWos[i];
        if (task.id == data.id) {
          stylee = 'highlight';
          break;
        }
      }
      // console.log(stylee);
      //这里输出一下冲突wo，要清除掉红色样式
      return stylee;
    };
    gantt.templates.task_text = (start, end, task) => {
      if (task.dType != 'task') {
        return '';
      }

      let txt = "<div style='position: relative;width: 100%;'>" + " <div style='position: absolute;z-index: 1;width: 100%;display: flex;justify-content: center;align-items: center;height:25px'><span style='color: " + 'white' + "'>" + task.text + '</span></div>';

      let chongtuWos = [];
      for (var i = 0; i < this.tasks.data.length; i++) {
        let data = this.tasks.data[i];

        if (task.id == data.id) {
          continue;
        }
        if (data.dType != 'task') {
          continue;
        }
        if (task.wo.mouldObject.no != data.wo.mouldObject.no) {
          continue;
        }
        if (data.parent == task.parent) {
          continue;
        }

        if (!this.checkTimes(task.start_date, task.end_date, data.start_date, data.end_date)) {
          chongtuWos.push(data);
        }
      }

      if (task.wo.status == '2') {
        let imgsrc = require('@@/assets/img/web/aps/yifafang.png');
        txt += " <div style='position: absolute;z-index: 2;display: flex;justify-content: space-between;align-items: center;height:25px'><img style='width: 20px;height: 20px;pointer-events: none;' src='" + imgsrc + "' /></div>";
      }
      if (chongtuWos.length > 0) {
        let imgsrc = require('@@/assets/img/web/aps/mojuchongtu.png');
        txt += " <div style='position: absolute;z-index: 2;right:4px;display: flex;justify-content: space-between;align-items: center;height:25px'><img style='width: 20px;height: 20px;pointer-events: none;' src='" + imgsrc + "' /></div>";
      }

      return txt;
    };

    gantt.attachEvent('onTaskClick', (id, e) => {
      const task = gantt.getTask(id);

      if (task.dType != 'task') {
        return false;
      }

      gantt.deleteMarker(this.jiaoqiMarker);

      this.jiaoqiMarker = gantt.addMarker({
        start_date: this.dayjs(task.wo.deliveryPeriodDate),
        css: 'today',
        text: this.$t('jiaoqi')
      });

      //any custom logic here
      setTimeout(() => {
        gantt.setSizes();
      }, 0);
      // this.$nextTick(() => {
      //   gantt.setSizes();
      // });
      return true;
    });
    gantt.attachEvent('onTaskDblClick', (id, e) => {
      const task = gantt.getTask(id);
      if (task.dType != 'task') {
        return false;
      }
      this.activeName = 'zhuchanpin';
      this.currentTask = task; //判断模具冲突需要用到
      console.log(task);
      this.currentWo = task.wo;
      this.isShowDetailDialog = true;
      //return false就不会执行默认的弹框操作

      return false;
    });

    let dragingTaskBeginStartDate = null;
    let dragingTaskStartDate = null;
    gantt.attachEvent('onBeforeTaskDrag', (id, mode, e) => {
      const task = gantt.getTask(id);
      if (task.dType == 'change') {
        this.utils.errorMessage(this.$t('bunengtuodonghuanxing'));
        return false;
      }
      if (task.wo.status == '2') {
        this.utils.errorMessage(this.$t('buyunxutuodongyifafangpaicheng'));
        return false;
      }
      dragingTaskBeginStartDate = task.start_date;
      console.log('onBeforeTaskDrag');
      return true;
    });
    gantt.attachEvent('onTaskDrag', function(id, mode, task, original) {
      //any custom logic here
      dragingTaskStartDate = task.start_date;
      console.log('onTaskDrag');

      // console.log(task.start_date + "|" + task.end_date)
      //console.log(dragingTaskStartDate)
    });
    gantt.attachEvent('onAfterTaskDrag', (id, mode, e) => {
      // const task = gantt.getTask(id);
      console.log('onAfterTaskDrag');
    });
    gantt.attachEvent('onBeforeTaskChanged', (id, mode, task) => {
      console.log('onBeforeTaskChanged');

      if (task.j == 0) {
        if (dragingTaskStartDate < this.dayjs()) {
          this.utils.errorMessage(this.$t('bunengzaoyudangqianshijian'));
          return false;
        }
        this.eqs[task.i].taskList[task.j].planStartTime = this.dayjs(dragingTaskStartDate).valueOf();

        let sPos = gantt.getScrollState();
        let data = this.reloadData();
        this.tasks.data = data;
        gantt.parse(this.tasks);
        gantt.scrollTo(sPos.x, sPos.y);
        this.needSave = true;
        return true;
      } else {
        //因为遮挡问题，不允许往后拖
        if (dragingTaskBeginStartDate < dragingTaskStartDate) {
          this.utils.errorMessage(this.$t('qingconghoumianwangqianmiantiaozheng'));
          return false;
        }
        //根据开始时间找出穿插的
        //先从data找出来，然后从eqs进行修改，因为reloadData靠的就是原始数据eqs，所以不直接修改data
        for (var i = 0; i < this.tasks.data.length; i++) {
          let inserted = this.tasks.data[i];

          //排除其他设备的
          if (inserted.i != task.i) {
            continue;
          }
          //排除自身
          if (inserted.id == task.id) {
            continue;
          }

          //找出最早开始时间大于自身的开始时间的，进行修改原数据

          if (inserted.start_date >= dragingTaskStartDate) {
            if (inserted.wo.status == '2') {
              console.log(inserted.wo);
              this.utils.errorMessage(this.$t('buyunxutuodongdaoyifafangpaichengzhiqian'));
              return false;
            }

            //如果是插入到排头第一，那么时间改为第一条的开始时间
            if (inserted.j == 0) {
              this.eqs[task.i].taskList[task.j].planStartTime = inserted.start_date.valueOf();
            }
            this.eqs[inserted.i].taskList = this.moveArrayItem(this.eqs[task.i].taskList, task.j, inserted.j);

            let sPos = gantt.getScrollState();
            let data = this.reloadData();
            this.tasks.data = data;
            gantt.parse(this.tasks);
            gantt.scrollTo(sPos.x, sPos.y);
            this.needSave = true;
            return true;
          }
        }
      }

      return false;
    });
    gantt.attachEvent('onAfterTaskUpdate', function(id, item) {
      //any custom logic here
      console.log('onAfterTaskUpdate' + id);
    });

    this.getGantt();
  },
  methods: {
    showTable() {
      this.isShowTableDialog = true;
    },
    //获取两个日期之间的所有日期
    enumerateDaysBetweenDates(startDate, endDate) {
      let daysList = [];
      const start = this.dayjs(startDate);
      const end = this.dayjs(endDate);
      const day = end.diff(start, 'day');

      console.log(this.dayjs(startDate).format('YYYY-MM-DD'), this.dayjs(endDate).format('YYYY-MM-DD'), day);
      daysList.push([start.year(), start.month(), start.date()]);
      for (let i = 0; i < day; i++) {
        daysList.push([start.add(i + 1, 'day').year(), start.add(i + 1, 'day').month(), start.add(i + 1, 'day').date()]);
      }
      return daysList;
    },
    //移动数组
    moveArrayItem(arr, from, to) {
      arr.splice(to, 0, arr[from]);
      if (to > from) {
        arr.splice(from, 1);
      } else {
        arr.splice(from + 1, 1);
      }
      return arr;
    },
    checkTimes(start1, end1, start2, end2) {
      //交集判断情况较多，我们采用非交集取反的方式，
      //非交集有两种情况，12AB  AB12
      //即1结束时间小于等于2开始时间或者1开始时间大于等于2结束时间
      if (!(end1 <= start2 || start1 >= end2)) {
        return false;
      }
      return true;
    },
    checkIsStop(eqId, date) {
      let eq = null;
      for (let i = 0; i < this.eqs.length; i++) {
        if (this.eqs[i].id == eqId) {
          eq = this.eqs[i];
        }
      }
      let day = 0;
      if (date.getDay() == 0) {
        //星期天
        day = 6;
      } else {
        day = date.getDay() - 1;
      }
      if (eq.weekly == null || eq.specify == null) {
        return '';
      }
      let hours = eq.weekly[day].hours;
      let specify = eq.specify;
      for (let i = 0; i < hours.length; i++) {
        let hour = hours[i];
        let starHour = this.dayjs(date).format('YYYY-MM-DD') + ' ' + hour.split('-')[0];
        let endHour = this.dayjs(date).format('YYYY-MM-DD') + ' ' + hour.split('-')[1];

        if (this.dayjs(date).isBetween(starHour, endHour)) {
          return true;
        }
      }

      for (let i = 0; i < specify.length; i++) {
        if (this.dayjs(date).isBetween(specify[i][0], specify[i][1])) {
          return true;
        }
      }

      return false;
    },
    countStopDuration(eqId, date, duration, stopDuration) {
      let step = Math.ceil(duration / 10000) * 10;
      stopDuration = stopDuration == null ? 0 : stopDuration;
      if (this.checkIsStop(eqId, this.dayjs(date).toDate())) {
        date = this.dayjs(date)
          .add(step, 'minute')
          .valueOf();
        stopDuration += step;
      } else {
        date = this.dayjs(date)
          .add(step, 'minute')
          .valueOf();
        duration -= step;
        //console.log(duration)
      }
      if (duration <= 0) {
        return stopDuration;
      } else {
        return this.countStopDuration(eqId, date, duration, stopDuration);
      }
    },

    //保存
    save() {
      let params = [];
      // console.log(this.tasks.data);
      for (let i = 0; i < this.tasks.data.length; i++) {
        let task = this.tasks.data[i];
        if (task.dType != 'task') {
          continue;
        }

        params.push({
          id: task.id,
          planStartTime: task.start_date.valueOf(),
          planEndTime: task.end_date.valueOf()
        });
      }
      // this.loading = true;
      this.loading = true;
      this.http
        .post('/web/ips/save', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.getGantt();
          this.loading = false;
        })
        .catch(err => {
          this.utils.errorMessage(err);
          this.loading = false;
        })
        .finally(() => {
          // this.loading = false;
          this.loading = false;
        });

      // let sPos = gantt.getScrollState();
      // let data = this.reloadData();
      // this.tasks.data = data;
      // gantt.parse(this.tasks);
      // gantt.scrollTo(sPos.x, sPos.y);
    },
    // handleChange() {
    // 	this.getGantt()
    // },
    //导入插单
    importInsertOrder() {
      this.isShowOrderImport = false;
      this.getGantt();
    },

    // 导出图片
    exportPic() {
      if (this.isExporting) {
        return;
      }
      this.isExporting = true;
      this.exportWidth = document.getElementById('device_load_gantt').getElementsByClassName('gantt_task_bg')[0].offsetWidth + 135;
      this.exportHeight = document.getElementById('device_load_gantt').getElementsByClassName('gantt_task_bg')[0].offsetHeight + 135;
      setTimeout(() => {
        gantt.setSizes();
      }, 300);

      setTimeout(() => {
        html2canvas(document.getElementById('device_load_gantt'), {
          // backgroundColor: 'white',
          // useCORS: true,
          // scale: 1,
          windowWidth: 2000, // document.getElementById('ganttContainer').scrollWidth,
          windowHeight: document.getElementById('ganttContainer').scrollHeight
        }).then(canvas => {
          let dataURL = canvas.toDataURL('image/png');
          if (dataURL !== '') {
            var a = document.createElement('a');
            a.download = 'gantt';
            a.href = dataURL;
            a.click();
          }
        });
      }, 600);

      setTimeout(() => {
        this.exportWidth = 0;
        this.exportHeight = 0;
        this.getGantt();
        this.isExporting = false;
      }, 900);
    },

    getGantt(isScrollRearrangement = false) {
      //放在clearAll之前才能准确定位
      let sPos = gantt.getScrollState();

      this.loading = true;
      gantt.clearAll();
      this.needSave = false;
      this.http
        .get('/web/intelligent/scheduling/details/apsGanttChart', { params: { orgId: this.orgId, planNo: this.planNo } })
        .then(res => {
          this.eqs = res.data;

          this.setCalendar();

          let data = this.reloadData();

          this.tasks.data = data;
          this.loading = false;
          setTimeout(() => {
            gantt.init(this.$refs.ganttContainer);
            gantt.parse(this.tasks);
            gantt.scrollTo(sPos.x, sPos.y);
            this.loading = false;
          }, 100);

          console.log(sPos.x, sPos.y);

          //排产明细不应该被截断，感觉
          if (this.startTime != null || this.endTime != null) {
            gantt.config.start_date = new Date(this.startTime);
            gantt.config.end_date = new Date(this.endTime);
          } else {
            // gantt.config.start_date = new Date(startTime);
            // gantt.config.end_date = new Date(endTime);
          }

          setTimeout(() => {
            gantt.setSizes();
          }, 0);

          if (isScrollRearrangement) {
            this.scrollRearrangement();
          }
          for (var i = 0; i < this.eqs.length; i++) {
            let eq = this.eqs[i];
            if (eq.taskList && eq.taskList.length > 0) {
              for (var j = 0; j < eq.taskList.length; j++) {
                if (eq.taskList[j].planObject && eq.taskList[j].planObject.no == this.planNo) {
                  this.activeName = 'zhuchanpin';
                  this.currentWo = eq.taskList[j];
                  this.isShowDetailDialog = true;
                  break;
                }
              }
            }
          }
        })
        .catch(err => {
          this.utils.errorMessage(err);
          this.loading = false;
        });
    },
    setCalendar() {
      //设置日历
      for (var i = 0; i < this.eqs.length; i++) {
        let eq = this.eqs[i];
        gantt.addCalendar({
          id: eq.id,
          worktime: {
            hours: ['00:00-24:00'],
            days: [1, 1, 1, 1, 1, 1, 1]
          }
        });
        if (eq.equipmentShutdownPlan == null) {
          continue;
        }

        let weekly = [];
        for (var j = 0; j < 7; j++) {
          weekly.push({
            day: j + 1,
            hours: []
          });
        }
        let specify = [];

        for (var j = 0; j < eq.equipmentShutdownPlan.length; j++) {
          let plan = eq.equipmentShutdownPlan[j];
          if (plan.shutdownType == '1') {
            let daysArr = this.enumerateDaysBetweenDates(plan.specifyStartTime, plan.specifyEndTime);
            //特定时间段
            for (var k = 0; k < daysArr.length; k++) {
              if (daysArr.length == 1) {
                //如果只有一条，那工作时间应该是有两段，就是0到开始，结束到24
                specify.push({
                  date: new Date(daysArr[k][0], daysArr[k][1], daysArr[k][2]),
                  hours: ['00:00' + '-' + this.dayjs(plan.specifyStartTime).format('HH:mm'), this.dayjs(plan.specifyEndTime).format('HH:mm') + '-' + '24:00']
                });
              } else {
                specify.push([plan.specifyStartTime, plan.specifyEndTime]);
              }
            }
          } else if (plan.shutdownType == '2') {
            weekly[parseInt(plan.weekly) - 1].hours.push('00:00' + '-' + plan.weekStartTime, plan.weekEndTime + '-' + '24:00');
          }
        }

        this.eqs[i].weekly = weekly;
        this.eqs[i].specify = specify;
      }
    },
    reloadData() {
      let startTime = this.startTime;
      let endTime = this.endTime;
      let data = [];
      //上面设置好了duration，下面不用再麻烦计算
      for (var i = 0; i < this.eqs.length; i++) {
        let eq = this.eqs[i];
        if (eq.taskList == null) {
          continue;
        }

        for (var j = 0; j < eq.taskList.length; j++) {
          eq.taskList[j].duration = (((eq.taskList[j].schedulingQuantity - (eq.taskList[j].woObject ? eq.taskList[j].woObject.productionQuantity : 0)) / eq.taskList[j].cavity) * (eq.taskList[j].standardCycle / 1000)) / 60;
          //这里如果计算出来小于0，强制等于0，开合模超产的缘故
          if (eq.taskList[j].duration < 0) {
            eq.taskList[j].duration = 0;
          }
          eq.taskList[j].durationOrigin = eq.taskList[j].duration;
          if (eq.taskList[j].durationOrigin <= 0) {
            console.log('aps常驻调试0', i, j, eq.taskList[j].durationOrigin, eq.taskList[j]);
          }
        }
      }
      console.log('aps常驻调试0');

      A: for (var i = 0; i < this.eqs.length; i++) {
        let eq = this.eqs[i];

        console.log(eq.equipmentName, new Date(startTime + 10000));
        data.push({
          id: 'eq_' + eq.id, // eq.equipmentId,
          calendar_id: 'eq_' + eq.id,
          text: eq.equipmentName,
          start_date: new Date(startTime), //设备加上start和end，那么就会出现这个设备
          end_date: new Date(startTime), //设备加上start和end，那么就会出现这个设备
          duration: 0,
          progress: 0,
          render: 'split',
          parent: null,
          type: 'subproject',
          // color:'transparent',
          textColor: 'transparent',
          chongtuWos: [],
          equipmentCurrentStatus: eq.equipmentCurrentStatus
        });
        // if(i==1){
        // 	continue
        // }
        console.log('aps常驻调试1：', i);

        if (eq.taskList == null) {
          continue;
        }
        console.log('aps常驻调试11：', i);

        for (var j = 0; j < eq.taskList.length; j++) {
          let wo = eq.taskList[j];
          //计算开始时间

          let currentStartDate = null;
          if (j > 0) {
            //拿上一条，这里必须拿data里面的，因为上一条可能是换型
            let last_data = data[data.length - 1];

            currentStartDate = this.dayjs.unix(this.dayjs(last_data.start_date).unix() + last_data.durationOrigin * 60).format('YYYY-MM-DD HH:mm:ss');
            console.log('aps常驻调试12：', i, j, last_data);

            console.log('aps常驻调试12：', i, j, last_data.start_date, last_data.durationOrigin);
          } else {
            //本设备第一条

            currentStartDate = this.dayjs.unix(wo.planStartTime / 1000).format('YYYY-MM-DD HH:mm:ss');
            console.log('aps常驻调试13：', i, j, currentStartDate);
          }
          //超出范围的就continue了

          if (this.dayjs(currentStartDate).unix() > this.endTime / 1000) {
            console.log('aps常驻调试14：', i, j, currentStartDate, this.dayjs(currentStartDate).unix(), this.endTime / 1000);
            // continue A;
          }

          //获取交期
          console.log('aps常驻调试2：', i, j, currentStartDate, wo.duration);

          let woStopDuration = this.countStopDuration(eq.id, currentStartDate, wo.duration);
          console.log('aps常驻调试3：', i, j);

          // prettier-ignore

          // eq.taskList[j].status=="2"

          //是否超期
          let isExpired = null
          let duration = 0;
          let durationOrigin = 0;

          if (wo.woObject && wo.woObject.status == '3') {
            //生产中都是第一条，直接用首工序完工时间来做对比
            isExpired = wo.deliveryPeriodDate / 1000 <= wo.woObject.firstProcessFinishTime / 1000;
            //用首工序完工时间减去开始时间直接计算分钟数
            duration = (wo.woObject.firstProcessFinishTime / 1000 - this.dayjs(currentStartDate).unix()) / 60;
            durationOrigin = (wo.woObject.firstProcessFinishTime / 1000 - this.dayjs(currentStartDate).unix()) / 60;

            console.log(i, j);
          } else {
            //非生产中
            isExpired = wo.deliveryPeriodDate / 1000 <= this.dayjs(currentStartDate).unix() + wo.duration * 60 + woStopDuration * 60;
            duration = wo.duration + woStopDuration;
            durationOrigin = wo.durationOrigin + woStopDuration;
          }

          console.log('aps常驻调试4：', i, j);
          console.log('aps常驻调试4：', i, j);

          data.push({
            i: i,
            j: j,
            wo: wo,
            calendar_id: 'eq_' + eq.id,
            id: wo.id,
            text: wo.materialObject.name + ' ' + (wo.woObject ? ((wo.woObject.productionQuantity / wo.schedulingQuantity) * 100).toFixed(1) + '%' : '0.0%'),
            start_date: currentStartDate,
            duration: duration, // + this.countStopDuration(eq.id, currentStartDate, wo.duration),
            durationOrigin: durationOrigin,
            progress: wo.woObject ? wo.woObject.productionQuantity / wo.schedulingQuantity : 0,
            parent: 'eq_' + eq.id,
            color: isExpired ? '#f56c6c' : '#85CE61',
            dType: 'task',
            chongtuWos: []
          });

          console.log('aps常驻调试5:' + i + '|' + j);

          //如果有下一条，则判断换模时间
          if (j < eq.taskList.length - 1) {
            let last_data = data[data.length - 1];
            let changeStartDate = this.dayjs.unix(this.dayjs(last_data.start_date).unix() + last_data.durationOrigin * 60).format('YYYY-MM-DD HH:mm:ss');
            let nextWo = eq.taskList[j + 1];
            let changeMoLiao = {
              prewo: wo,
              nextWo: nextWo,
              calendar_id: 'eq_' + eq.id, //工作日历id，用来设置停产时间
              id: wo.id + '_' + nextWo.id,
              text: ' ',
              start_date: changeStartDate,
              duration: 0,
              durationOrigin: 0,
              progress: 0,
              parent: 'eq_' + eq.id,
              color: '#e9e9eb',
              dType: 'change',
              chongtuWos: []
            };
            //换模换料
            console.log('aps常驻调试6：' + i + '|' + j);

            if (wo.materialObject.code != nextWo.materialObject.code && wo.mouldObject.no != nextWo.mouldObject.no) {
              changeMoLiao.duration = eq.changeMouldAndMaterialTime ? eq.changeMouldAndMaterialTime : 0; //+ 1200
              changeMoLiao.durationOrigin = eq.changeMouldAndMaterialTime ? eq.changeMouldAndMaterialTime : 0; // + 1200
              changeMoLiao.changeType = 'huanmohuanliao';
              console.log(nextWo.changeMouldAndMaterialTime);
            }
            //换料
            else if (wo.materialObject.code != nextWo.materialObject.code) {
              changeMoLiao.duration = eq.changeMaterialTime ? eq.changeMaterialTime : 0; // + 1200
              changeMoLiao.durationOrigin = eq.changeMaterialTime ? eq.changeMaterialTime : 0; //+ 1200
              changeMoLiao.changeType = 'huanliao';
            }
            //换模
            else if (wo.mouldObject.no != nextWo.mouldObject.no) {
              changeMoLiao.duration = eq.changeMouldTime ? eq.changeMouldTime : 0; //+1200
              changeMoLiao.durationOrigin = eq.changeMouldTime ? eq.changeMouldTime : 0; //+ 1200
              changeMoLiao.changeType = 'huanmo';
            }

            //加上停产时间
            changeMoLiao.duration = changeMoLiao.duration + this.countStopDuration(eq.id, changeStartDate, changeMoLiao.duration);
            changeMoLiao.durationOrigin = changeMoLiao.durationOrigin + this.countStopDuration(eq.id, changeStartDate, changeMoLiao.durationOrigin);

            data.push(changeMoLiao);
          }
        }
      }
      console.log(data);
      return data;
    },

    resize() {
      setTimeout(() => {
        gantt.setSizes();
        // this.getGantt()
      }, 500);
    },
    insertWo(wos) {
      console.log(wos);
    },

    //删除超交期的原始数据
    checkSchedulingDetails() {
      this.loading = true;
      let params = [];
      // console.log(this.tasks.data);
      for (let i = 0; i < this.tasks.data.length; i++) {
        let task = this.tasks.data[i];
        if (task.dType != 'task') {
          continue;
        }
        params.push(task.wo);
      }
      this.http
        .post('/web/ips/checkSchedulingDetails', params)
        .then(res => {
          //再进行滚动重排
          this.getGantt(true);
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //滚动重排,改原始数据
    scrollRearrangement() {
      this.loading = true;
      //上面设置好了duration，下面不用再麻烦计算
      for (var i = 0; i < this.eqs.length; i++) {
        let eq = this.eqs[i];
        if (eq.taskList == null) {
          continue;
        }

        for (var j = 0; j < eq.taskList.length; j++) {
          if (eq.taskList[j].status == '2' && eq.taskList[j].woObject && eq.taskList[j].woObject.status == '3' && eq.taskList[j].woObject.actualStartTime) {
            eq.taskList[j].planStartTime = eq.taskList[j].woObject.actualStartTime;
            //已发放并且是生产中的
          } else {
            //其他的改当前时间为开始时间
            eq.taskList[j].planStartTime = this.dayjs().valueOf();
          }
        }
      }

      let sPos = gantt.getScrollState();
      let data = this.reloadData();
      this.tasks.data = data;
      gantt.parse(this.tasks);
      gantt.scrollTo(sPos.x, sPos.y);
      this.needSave = true;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    //批量发放
    batchIssue(wos) {
      //   //找出同模具的又时间重叠的
      for (var i = 0; i < this.tasks.data.length; i++) {
        let data = this.tasks.data[i];
        if (data.dType != 'task') {
          continue;
        }

        for (var j = 0; j < this.tasks.data.length; j++) {
          let task = this.tasks.data[j];

          if (task.id == data.id) {
            continue;
          }
          if (task.dType != 'task') {
            continue;
          }
          console.log(task.id, task.wo);
          if (task.wo.mouldId != data.wo.mouldId) {
            continue;
          }
          if (data.parent == task.parent) {
            continue;
          }
          if (!this.checkTimes(task.start_date, task.end_date, data.start_date, data.end_date)) {
            this.utils.errorMessage(this.$t('qingjiejuewanmojuchongtuhouzaifafang'));
            return;
          }
        }
      }

      this.loading = true;
      let params = {};
      this.http
        .post('/web/ips/batchIssue', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.getGantt();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //发放
    issue() {
      for (var i = 0; i < this.tasks.data.length; i++) {
        let data = this.tasks.data[i];

        if (this.currentTask.id == data.id) {
          continue;
        }
        if (data.dType != 'task') {
          continue;
        }
        if (this.currentTask.wo.mouldId != data.wo.mouldId) {
          continue;
        }
        if (data.parent == this.currentTask.parent) {
          continue;
        }
        if (!this.checkTimes(this.currentTask.start_date, this.currentTask.end_date, data.start_date, data.end_date)) {
          this.utils.errorMessage(this.$t('qingjiejuewanmojuchongtuhouzaifafang'));

          return;
        }
      }

      this.loading = true;
      let params = {
        id: this.currentWo.id
      };
      this.http
        .post('/web/ips/issue', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowDetailDialog = false;
          this.getGantt();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //取消发放
    cancelIssue() {
      this.loading = true;
      let params = {
        id: this.currentWo.id
      };
      this.http
        .post('/web/ips/cancelIssue', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowDetailDialog = false;
          this.getGantt();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //打开更换模具
    showChangeMould() {
      this.loading = true;
      this.http
        .get('/web/aps/plan/queryMould', {
          params: {
            detailId: this.currentWo.id
          }
        })
        .then(res => {
          this.changeMoulds = res.data;
          this.changeMould = this.currentWo.mouldId;
          this.isShowChangeMould = true;
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //更换模具
    changeMouldF() {
      this.loading = true;
      let params = {
        mouldId: this.changeMould,
        detailId: this.currentWo.id
      };
      this.http
        .post('/web/ips/changeMould', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowChangeMould = false;
          this.isShowDetailDialog = false;
          this.getGantt();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //打开更换机台
    showChangeEq() {
      this.loading = true;
      this.http
        .get('/web/aps/plan/queryEquipment', {
          params: {
            detailId: this.currentWo.id
          }
        })
        .then(res => {
          console.log(res);
          this.changeEqs = res.data;
          this.changeEq = this.currentWo.equipmentId;
          this.isShowChangeEq = true;
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //更换机台
    changeEquipment() {
      this.loading = true;
      let params = {
        equipmentId: this.changeEq,
        detailId: this.currentWo.id
      };
      this.http
        .post('/web/ips/changeEquipment', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowChangeEq = false;
          this.isShowDetailDialog = false;
          this.getGantt();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //打开拆单
    showSplitOrder() {
      this.isShowSplitOrder = true;
      this.splitOrders = [];
      this.splitOrders.push(0);
    },
    //拆单
    splitOrder() {
      let abundance = this.splitOrders.filter(item => {
        if (item != 0) {
          return true;
        }
        return false;
      });
      // this.loading = true;
      let params = {
        abundance: abundance,
        detailId: this.currentWo.id
      };
      this.loading = true;
      this.http
        .post('/web/ips/dismantlingDoc', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowSplitOrder = false;
          this.isShowDetailDialog = false;
          this.getGantt();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //锁定
    lock() {
      this.loading = true;
      let params = {
        detailId: this.currentWo.id
      };
      this.http
        .post('/web/ips/lock', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowDetailDialog = false;
          this.getGantt();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //取消排程
    cancelScheduling() {
      this.loading = true;
      let params = {
        detailId: this.currentWo.id
      };
      this.http
        .post('/web/ips/cancelScheduling', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowDetailDialog = false;
          this.getGantt();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //强制关闭
    forceClose() {
      this.loading = true;
      let params = {
        detailId: this.currentWo.id
      };
      this.http
        .post('/web/ips/forceClose', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowDetailDialog = false;
          this.getGantt();
          this.loading = false;
        })
        .catch(err => {
          this.utils.errorMessage(err);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    //拆单
    dismantlingDoc() {
      // this.loading = true;
      let params = {
        planId: planId.id,
        abundance: []
      };
      this.http
        .post('/web/ips/dismantlingDoc', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowDetailDialog = false;
          this.getGantt();
          this.isShowChadanButton = false;
          this.$nextTick(() => {
            this.isShowChadanButton = true;
          });
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //挂起
    pending() {
      this.loading = true;
      let params = {
        id: this.currentWo.id
      };
      this.http
        .post('/web/intelligent/scheduling/details/pending', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowDetailDialog = false;
          this.getGantt();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //取消挂起
    cancelPending() {
      this.loading = true;
      let params = {
        id: this.currentWo.id
      };
      this.http
        .post('/web/intelligent/scheduling/details/cancelPending', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.isShowDetailDialog = false;
          this.getGantt();
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    //插单
    getImportWos(order) {
      if (order == null) {
        this.utils.errorMessage($t('qingxuanze'));
        return;
      }
      // this.loading = true;
      let params = {
        ids: this.importIds.join(',')
      };
      this.http
        .get('/web/aps/plan/insertOrder', {
          params: params
        })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.getGantt();
          this.importIds = null;
          this.isShowChadanButton = false;
          this.$nextTick(() => {
            this.isShowChadanButton = true;
          });
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          // this.loading = false;
        });
    },
    issued() {
      let issuedIds = this.$refs.equipmentIssueRef.allIds;
      if (issuedIds.length == 0) {
        this.utils.errorMessage(this.$t('qingxuanze'));
        return;
      }
      this.issuedLoading = true;
      this.http
        .get('/web/intelligent/scheduling/details/equipmentScheduling', { params: { ids: issuedIds } })
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.$refs.equipmentIssueRef.yt.conditions.orderBy = 'planStartTime asc';
          this.$refs.equipmentIssueRef.yt.conditions.status = '1';
          this.$refs.equipmentIssueRef.yt.conditions.pageSize = 999;
          this.$refs.equipmentIssueRef.yt.get(1);
          this.issuedLoading = false;
        })
        .catch(err => {
          this.utils.errorMessage(err);
        })
        .finally(() => {
          this.issuedLoading = false;
        });
    }
  }
};
</script>
Ref
